import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { Formik } from 'formik';
import { Button, Grid, Paper, TextField, Typography, Checkbox } from '@material-ui/core';
import ModalRoot from 'components/Modal/ModalRoot';

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'scroll',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  title: {
    ...theme.Typography,
    color: '#044591',
  },
  bottomContainer: {
    display: 'flex',
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end',
  },
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 26,
    minHeight: 200,
  }),
  checkboxContainer: {
    display: 'flex',
  },
});

const initialValues = {
  name: '',
  email: '',
  phone: '',
  code: '',
  limit: '',
  expireAt: '',
  hasLimit: false,
  isExpirable: false,
};

const validate = values => {
  const errors = {};

  for (const key of ['name', 'email', 'phone', 'code']) {
    if (!values[key]) {
      errors[key] = 'Required';
    }
  }

  return errors;
};

class AgencyCodeNew extends React.Component {
  render() {
    const { classes, onSubmit, history } = this.props;

    return (
      <Formik validate={validate} initialValues={initialValues} onSubmit={onSubmit}>
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => {
          const props = (name, label) => ({
            name,
            label,
            value: values[name],
            onChange: handleChange,
            onBlur: handleBlur,
            error: touched[name] && !!errors[name],
            helperText: (touched[name] && errors[name]) || ' ',
            inputProps: { maxLength: 100 },
            required: true,
            fullWidth: true,
          });

          return (
            <form
              onSubmit={handleSubmit}
              className={classes.content}
              noValidate
              autoComplete="off"
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography className={classes.title} variant="h6">
                    Create a new referral code
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Paper className={classes.root} elevation={0}>
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <TextField {...props('name', 'Full Name')} />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField {...props('email', 'Email')} />
                      </Grid>

                      <Grid item xs={3}>
                        <TextField {...props('phone', 'Phone')} />
                      </Grid>

                      <Grid item xs={3}>
                        <TextField {...props('code', 'Referral Code')} />
                      </Grid>

                      <Grid item xs={3} className={classes.checkboxContainer}>
                        <Checkbox
                          value={values.isExpirable.toString()}
                          name="isExpirable"
                          checked={values.isExpirable}
                          onChange={e => {
                            values.expireAt = '';
                            handleChange(e);
                          }}
                        />

                        <TextField
                          {...props('expireAt', 'Expire date')}
                          type="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled={!values.isExpirable}
                          required={false}
                        />
                      </Grid>

                      <Grid item xs={3} className={classes.checkboxContainer}>
                        <Checkbox
                          value={values.hasLimit.toString()}
                          name="hasLimit"
                          checked={values.hasLimit}
                          onChange={e => {
                            values.limit = '';
                            handleChange(e);
                          }}
                        />

                        <TextField
                          {...props('limit', 'Usage limit')}
                          type="number"
                          disabled={!values.hasLimit}
                          required={false}
                        />
                      </Grid>
                    </Grid>
                  </Paper>

                  <div className={classes.bottomContainer}>
                    <Button
                      variant="text"
                      color="default"
                      className={classes.button}
                      onClick={() => history.push('/dashboard/agency')}
                    >
                      cancel
                    </Button>

                    <Button
                      type="submit"
                      variant="text"
                      color="primary"
                      className={classes.button}
                      disabled={isSubmitting}
                    >
                      create
                    </Button>
                  </div>
                </Grid>
              </Grid>

              <ModalRoot />
            </form>
          );
        }}
      </Formik>
    );
  }
}

export default withStyles(styles)(AgencyCodeNew);
